import { useState, useEffect } from "react";
import { AiFillInfoCircle } from "react-icons/ai";
import EquipmentGroupActions from "../../Actions/EquipmentGroupActions";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";

const CopyEquipmentGroup = (props) => {
  const { equGrpDetailsForCopy, plantId, plantList } = props;
  const [equipmentGroupName, setEquipmentGroupName] = useState("");
  const [inventoryNoPrefix, setInventoryNoPrefix] = useState("");
  const [CopyFunctions, setCopyFunctions] = useState(true);
  const [CopyMenu, setCopyMenu] = useState(true);
  const [CopyAttribute, setCopyAttribute] = useState(true);
  const [CopyManufacturer, setCopyManufacturer] = useState(true);
  const [CopyTestGroup, setCopyTestGroup] = useState(true);
  const [CopyEquipmentName, setCopyEquipmentName] = useState(true);
  const [CopyPruefPlan, setCopyPruefPlan] = useState(false);
  const [selPlantId, setSelPlantId] = useState("");
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  useEffect(() => {
    setCopyFunctions(true);
    setCopyMenu(true);
    setCopyEquipmentName(true);
    setCopyAttribute(true);
    setCopyManufacturer(true);
    setCopyTestGroup(true);
    setSelPlantId(plantId);
    return () => {};
  }, [props]);

  const copyEquipmentGroupSubmit = (e) => {
    e.preventDefault();
    var copyEquipmentData = {
      PlantId: selPlantId,
      ID: equGrpDetailsForCopy.id,
      Bezeichnung: equipmentGroupName,
      Abkuerzung: inventoryNoPrefix,
      CopyFunctions: CopyFunctions,
      CopyMenu: CopyMenu,
      CopyAttribute: CopyAttribute,
      CopyManufacturer: CopyManufacturer,
      CopyTestGroup: CopyTestGroup,
      CopyEquipmentName: CopyEquipmentName,
      CopyPruefPlan: CopyPruefPlan,
    };
    setGlobalSpinner(true);
    EquipmentGroupActions.CopyEquipmentGroup(copyEquipmentData);
  };

  const resetData = () => {
    setEquipmentGroupName("");
    setInventoryNoPrefix("");
    setCopyFunctions(true);
    setCopyMenu(true);
    setCopyEquipmentName(true);
    setCopyAttribute(true);
    setCopyManufacturer(true);
    setCopyTestGroup(true);
  };

  const resetShowMessageOnPopUpFlag = () => {
    resetData();
  };

  return (
    <>
      <div
        className="modal fade"
        id="copyEquipmentGroup"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="copyEquipmentGroup"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="copyEquipmentGroupTitle">
                {localization.copyEquipmentGroup} -{" "}
                {equGrpDetailsForCopy?.bezeichnung}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="copyEquipmentGroupClose"
                onClick={resetShowMessageOnPopUpFlag}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form
              id="copyEquipmentGroupForm"
              name="copyEquipmentGroupForm"
              onSubmit={copyEquipmentGroupSubmit}
            >
              <div className="modal-body">
                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <label htmlFor="plantList">{localization.plant}</label>
                      <select
                        className="form-control"
                        id="plantList"
                        name="plantList"
                        required
                        value={selPlantId}
                        onChange={(e) => {
                          setSelPlantId(e.target.value);
                        }}
                      >
                        <option value="">{localization.selectPlant}</option>
                        {plantList.map((row, index) => {
                          return (
                            <option key={index} value={row.id}>
                              {row.bezeichnung}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="form-group">
                      <label
                        className="form-label"
                        htmlFor="equipmentGroupName"
                      >
                        {localization.designation}
                      </label>
                      <input
                        type="text"
                        id="equipmentGroupName"
                        name="equipmentGroupName"
                        className="form-control"
                        required
                        maxLength={32}
                        placeholder={localization.designation}
                        value={equipmentGroupName}
                        onChange={(e) => {
                          setEquipmentGroupName(e.target.value);
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label mr-4" htmlFor="shortcut">
                        {localization.shortcut}
                      </label>
                      <AiFillInfoCircle
                        className="cursorPoint svgIcon"
                        title={localization.shortcutPrefixInfo}
                      />
                      <input
                        type="text"
                        id="shortcut"
                        name="shortcut"
                        className="form-control"
                        required
                        placeholder={localization.shortcut}
                        value={inventoryNoPrefix}
                        onChange={(e) => {
                          setInventoryNoPrefix(e.target.value);
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label>{localization.selectFromOptions}</label>
                    </div>
                    <div className="form-check d-flex align-items-center">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="MenuCheckBox"
                        name="CopyMenu"
                        value="Menu"
                        checked={CopyMenu}
                        onChange={(event) => {
                          setCopyMenu(event.target.checked);
                        }}
                      ></input>
                      <label
                        className="form-check-label ml-2"
                        htmlFor="CopyMenu"
                      >
                        {localization.menu}
                      </label>
                    </div>

                    <div className="form-check d-flex align-items-center">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="StandardAttributeCheckBox"
                        name="CopyAttribute"
                        value="StandardAttributes"
                        checked={CopyAttribute}
                        onChange={(event) => {
                          setCopyAttribute(event.target.checked);
                        }}
                      ></input>
                      <label
                        className="form-check-label ml-2"
                        htmlFor="CopyAttribute"
                      >
                        {localization.standardAttribute}
                      </label>
                    </div>

                    <div className="form-check d-flex align-items-center">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="ManufacturerCheckBox"
                        name="CopyManufacturer"
                        value="Manufacturer"
                        checked={CopyManufacturer}
                        onChange={(event) => {
                          setCopyManufacturer(event.target.checked);
                        }}
                      ></input>
                      <label
                        className="form-check-label ml-2"
                        htmlFor="CopyManufacturer"
                      >
                        {localization.manufacturer}
                      </label>
                    </div>

                    <div className="form-check d-flex align-items-center">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="TestGroupCheckBox"
                        name="CopyTestGroup"
                        value="TestGroup"
                        checked={CopyTestGroup}
                        onChange={(event) => {
                          setCopyTestGroup(event.target.checked);
                        }}
                      ></input>
                      <label
                        className="form-check-label ml-2"
                        htmlFor="CopyTestGroup"
                      >
                        {localization.testGroups}
                      </label>
                    </div>

                    <div className="form-check d-flex align-items-center">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="NameOfEquipmentsCheckBox"
                        name="CopyEquipmentName"
                        value="NameOfEquipments"
                        checked={CopyEquipmentName}
                        onChange={(event) => {
                          setCopyEquipmentName(event.target.checked);
                        }}
                      ></input>
                      <label
                        className="form-check-label ml-2"
                        htmlFor="CopyEquipmentName"
                      >
                        {localization.nameOfEquipments}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="form-group marProp ">
                  <button
                    type="submit"
                    className="btn btn-primary btn-block mb-4"
                  >
                    {localization.save}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CopyEquipmentGroup;
